module.exports = __webpack_public_path__ + "img/nevhodna.3db80aa4.svg";